import { useState } from "react";
import { Loader2, ShieldCheck, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export const ChangePassword = ({ forced = false }) => {
    const { changePassword } = useAuth();
    const [current, setCurrent] = useState("");
    const [next, setNext] = useState("");
    const [confirm, setConfirm] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState("");

    const onSubmit = async (e) => {
        e.preventDefault();
        if (submitting) return;
        setError("");
        if (next.length < 10) {
            setError("Le nouveau mot de passe doit contenir au moins 10 caractères.");
            return;
        }
        if (next !== confirm) {
            setError("La confirmation ne correspond pas au nouveau mot de passe.");
            return;
        }
        setSubmitting(true);
        const res = await changePassword(current, next);
        setSubmitting(false);
        if (res.ok) {
            toast.success("Mot de passe mis à jour.");
            setCurrent("");
            setNext("");
            setConfirm("");
        } else {
            setError(res.error || "Impossible de modifier le mot de passe.");
        }
    };

    return (
        <div data-testid="change-password-panel" className="max-w-md">
            <div className="flex items-center gap-3 mb-2">
                <span className="h-px w-10 bg-[#DC2626]" />
                <span className="overline">Sécurité du compte</span>
            </div>
            <h2 className="font-serif text-2xl md:text-3xl">
                {forced ? "Définissez un nouveau mot de passe" : "Changer de mot de passe"}
            </h2>
            {forced ? (
                <p className="mt-3 text-sm text-[#64748B]">
                    Pour des raisons de sécurité, vous devez remplacer le mot de passe par défaut avant d’accéder à l’espace admin.
                </p>
            ) : (
                <p className="mt-3 text-sm text-[#64748B]">
                    Utilisez un mot de passe unique d’au moins 10 caractères.
                </p>
            )}

            <form onSubmit={onSubmit} data-testid="change-password-form" className="mt-8 space-y-2">
                <div>
                    <label className="overline text-[#64748B]">Mot de passe actuel</label>
                    <input
                        type="password"
                        value={current}
                        onChange={(e) => setCurrent(e.target.value)}
                        required
                        data-testid="cp-current"
                        className="field"
                        autoComplete="current-password"
                        placeholder="••••••••"
                    />
                </div>
                <div>
                    <label className="overline text-[#64748B]">Nouveau mot de passe</label>
                    <input
                        type="password"
                        value={next}
                        onChange={(e) => setNext(e.target.value)}
                        required
                        data-testid="cp-new"
                        className="field"
                        autoComplete="new-password"
                        placeholder="Au moins 10 caractères"
                    />
                </div>
                <div>
                    <label className="overline text-[#64748B]">Confirmer le nouveau mot de passe</label>
                    <input
                        type="password"
                        value={confirm}
                        onChange={(e) => setConfirm(e.target.value)}
                        required
                        data-testid="cp-confirm"
                        className="field"
                        autoComplete="new-password"
                        placeholder="••••••••"
                    />
                </div>

                {error && (
                    <div data-testid="cp-error" className="text-sm text-[#DC2626] pt-3">
                        {error}
                    </div>
                )}

                <button
                    type="submit"
                    disabled={submitting}
                    data-testid="cp-submit"
                    className="btn-primary mt-8 w-full justify-center disabled:opacity-60"
                >
                    {submitting ? (
                        <>
                            <Loader2 size={18} className="animate-spin" />
                            Enregistrement…
                        </>
                    ) : forced ? (
                        <>
                            <ShieldCheck size={16} strokeWidth={1.5} />
                            Sécuriser mon compte
                        </>
                    ) : (
                        <>
                            <KeyRound size={16} strokeWidth={1.5} />
                            Mettre à jour
                        </>
                    )}
                </button>
            </form>
        </div>
    );
};

export default ChangePassword;
